// Mobile menu toggle + scroll lock
const menuButton = document.querySelector('#ToggleMobileMenu');
const siteNav = document.querySelector('.site-nav');
const html = document.documentElement;
const body = document.body;

let scrollY = 0;

menuButton.addEventListener('click', () => {
  const isOpen = siteNav.classList.contains('is-open');

  if (!isOpen) {
    scrollY = window.scrollY;

    siteNav.classList.add('is-open');
    menuButton.classList.add('open');

    html.classList.add('menu-open');
    body.classList.add('menu-open');

    body.style.top = `-${scrollY}px`;
  } else {
    siteNav.classList.remove('is-open');
    menuButton.classList.remove('open');

    html.classList.remove('menu-open');
    body.classList.remove('menu-open');

    body.style.top = '';

    window.scrollTo(0, scrollY);
  }
});

// Progress Bar
// Thresholds are a currency keyed setting, e.g. "GBP:150,USD:250,INT:350".
// Shoppers outside the supported country list fall back to INT.

// These currencies have no minor unit, so 150 means 150 and not 15000.
const ZERO_DECIMAL_CURRENCIES = ['JPY', 'KRW', 'CLP', 'HUF', 'TWD'];

function parseThresholdMap(str) {
  const map = {};
  (str || '').split(',').forEach(pair => {
    const [key, value] = pair.split(':');
    const amount = parseFloat(value);
    if (key && Number.isFinite(amount)) map[key.trim().toUpperCase()] = amount;
  });
  return map;
}

function isSupportedCountry(wrapper) {
  const allowed = (wrapper.dataset.supportedCountries || '')
    .split(',')
    .map(s => s.trim().toUpperCase())
    .filter(Boolean);

  if (!allowed.length) return true;

  return allowed.includes((wrapper.dataset.country || '').toUpperCase());
}

function resolveThreshold(wrapper) {
  const currency = (wrapper.dataset.currency || '').toUpperCase();
  const map = parseThresholdMap(wrapper.dataset.thresholds);
  const multiplier = ZERO_DECIMAL_CURRENCIES.includes(currency) ? 1 : 100;

  const amount = isSupportedCountry(wrapper) ? map[currency] : map.INT;
  if (!Number.isFinite(amount)) return null;

  return Math.round(amount * multiplier);
}

function formatMoney(minorUnits, format) {
  const fmt = format || '{{amount}}';
  const amount = minorUnits / 100;

  const withSeparators = (value, decimals, decimalSep, thousandSep) => {
    const parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
    return parts.join(decimalSep);
  };

  return fmt
    .replace('{{amount_no_decimals_with_comma_separator}}', withSeparators(amount, 0, ',', '.'))
    .replace('{{amount_with_comma_separator}}', withSeparators(amount, 2, ',', '.'))
    .replace('{{amount_no_decimals}}', withSeparators(amount, 0, '.', ','))
    .replace('{{amount}}', withSeparators(amount, 2, '.', ','));
}

function updateProgressBar(cartTotal, itemCount) {
  const progressWrapper = document.getElementById('cart-progress-wrapper');
  if (!progressWrapper) return;

  const progressBar = document.getElementById('cart-progress-bar');
  const goalMessageElements = document.querySelectorAll('.goal-message');
  const threshold = resolveThreshold(progressWrapper);

  if (!itemCount || !cartTotal || !threshold) {
    progressWrapper.style.display = 'none';
    goalMessageElements.forEach(el => el.style.display = 'none');
    return;
  }

  progressWrapper.style.display = 'block';

  const progressPercentage = Math.min((cartTotal / threshold) * 100, 100);
  if (progressBar) {
    progressBar.style.display = 'block';
    progressBar.style.width = `${progressPercentage}%`;
  }
  progressWrapper.classList.toggle('full', progressPercentage >= 100);

  const moneyFormat = progressWrapper.dataset.moneyFormat;
  const preGoalMessageTemplate = progressWrapper.dataset.preGoalMessageTemplate;
  const postGoalMessage = progressWrapper.dataset.postGoalMessage;
  const remaining = Math.max(threshold - cartTotal, 0);

  goalMessageElements.forEach(el => {
    el.style.display = 'block';
    el.innerHTML = remaining > 0
      ? preGoalMessageTemplate.replace('[remaining_for_goal]', formatMoney(remaining, moneyFormat))
      : postGoalMessage;
  });
}

document.addEventListener('DOMContentLoaded', function () {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      console.log('Cart fetched:', cart);
      updateProgressBar(cart.total_price, cart.item_count);
    });
});


// Cart Drawer
function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();

  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();

  updateCartItemCounts(cart.item_count);
  updateProgressBar(cart.total_price, cart.item_count);  
}

async function updateMainCart() {
  const res = await fetch("/?section_id=main-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newMainCart = html.querySelector(".main-cart");
  const currentMainCart = document.querySelector(".main-cart");
  if (newMainCart && currentMainCart) {
    currentMainCart.innerHTML = newMainCart.innerHTML;
    addCartDrawerListeners(); // Re-bind quantity buttons
  }

  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();
  updateCartItemCounts(cart.item_count);
  updateProgressBar(cart.total_price, cart.item_count);
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        const rootItem = button.closest("[data-line-item-key]");
        const key = rootItem.getAttribute("data-line-item-key");

        const currentQuantity = Number(
          rootItem.querySelector("input").value
        );
        const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update both views if they exist
        if (document.querySelector(".cart-drawer")) updateCartDrawer();
        if (document.querySelector(".main-cart")) updateMainCart();
      });
    });

    // Prevent closing when clicking inside the drawer box
    const drawerBox = document.querySelector(".cart-drawer-box");
    if (drawerBox) {
      drawerBox.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }
    
    // Close drawer when clicking the background overlay
    const drawer = document.querySelector(".cart-drawer");
    if (drawer) {
      drawer.addEventListener("click", (e) => {
        if (e.target === drawer) {
          closeCartDrawer();
        }
      });
    }
    
    // Close drawer when clicking the close button
    document.querySelectorAll(".cart-drawer-header-right-close").forEach((btn) => {
      btn.addEventListener("click", closeCartDrawer);
    });
}

addCartDrawerListeners();

// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     // Update cart
//     await updateCartDrawer();

//     // Open cart drawer
//     openCartDrawer();
//   });
// });

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formData = new FormData(form);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    });

    const item = await res.json();

    // Fire Shopify Analytics event safely
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
      window.ShopifyAnalytics.lib.track("product_added_to_cart", {
        variant_id: item.variant_id,
        name: item.product_title,
        price: item.price / 100,
        quantity: item.quantity,
        sku: item.sku,
        brand: item.vendor,
      });
      console.log("ShopifyAnalytics: product_added_to_cart", item);
    }

    await updateCartDrawer();
    openCartDrawer();
  });
});

document.querySelectorAll('.top-bar a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

// Collection column switcher: 3 or 4 products per row.
(function () {
  const KEY = "crtz-collection-columns";
  const grid = document.getElementById("product-grid");
  const control = document.querySelector("[data-crtz-columns]");
  if (!grid || !control) return;

  // iOS private browsing throws on access rather than returning null.
  const stored = () => {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  };

  function apply(count) {
    grid.classList.toggle("crtz-cols-4", count === 4);

    control.querySelectorAll("[data-crtz-columns-value]").forEach((btn) => {
      const active = btn.dataset.crtzColumnsValue === String(count);
      btn.classList.toggle("is-selected", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  control.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-crtz-columns-value]");
    if (!btn) return;

    const count = btn.dataset.crtzColumnsValue === "4" ? 4 : 3;
    try { localStorage.setItem(KEY, String(count)); } catch (err) {}
    apply(count);
  });

  apply(stored() === "4" ? 4 : 3);
})();
